/**
 * メインアプリケーションファイル
 * 各モジュールを統合し、アプリケーション全体の初期化を管理
 */

import '../scss/style.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// 各機能モジュールのインポート（名前空間方式）
import * as Loading from './loading.js';
import * as Animations from './animations.js';
import * as Sliders from './sliders.js';
import * as Header from './header.js';
import * as Products from './products.js';
import * as Modal from './modal.js';
import * as Tabs from './tabs.js';
import * as Lightbox from './lightbox.js';
import * as Page from './page.js';

// GSAPプラグインとグローバル変数の設定
let mm = gsap.matchMedia();

// DOM読み込み前にクラス付与を実行（一瞬fixedになっていない表示を防ぐ）
// DOMContentLoadedまたは即座に実行
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      Page.addFixedClassEarly();
    });
  } else {
    // DOMが既に読み込まれている場合は即座に実行
    Page.addFixedClassEarly();
  }
})();

async function windowLoaded() {
  // GSAPのプラグインを登録
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // ローディングアニメーションの実行を待機
  await Loading.setupLoadingAnimation();

  // 初回読み込み時のアニメーション初期化
  Sliders.setupSlides();
  Animations.gsapFadeInUp();
  Animations.gsapFadeIn();
  Animations.gsapZoomIn();
  Animations.gsapSplits();
  // 飛行機アニメーション初期化
  Animations.setupPlaneAnimation();
  // バナーカルーセル初期化（ページ遷移後）
  Sliders.setupBannerCarousel();
  // 背景スライダー初期化
  Sliders.setupBackgroundSlider();
  // 学校スライダー初期化
  Sliders.setupSchoolSlider();
  // コラムスライダー初期化
  Sliders.setupColumnSlider();
  Products.setupProductHover();
  
  // ヘッダーのScrollTrigger設定
  Header.setupHeaderScrollTriggers();
  
  // モバイルメニューの初期化
  Header.setupMobileMenu();
  
  // モーダルの初期化
  Modal.setupApplicationModal();
  
  // タブ機能の初期化
  Tabs.setupTabs();
  
  // ライトボックスの初期化
  Lightbox.setupLightbox();
  
  // ページ機能の初期化
  Page.setupPageFeatures();

  // ブラウザのスクロール復元を無効化
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
}

window.addEventListener('load', () => {
  windowLoaded();
});

window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};

